export class SessionSettings {
  /**
   * Currently set facility
   */
  public currentFacility: string

  public static EMPTY(): SessionSettings {
    return new SessionSettings()
  }
}
